<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">

    <dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)" (onEditorPreparing)="onEditorPreparing($event)">

      <!-- Definición de las columnas -->
      <dxi-column dataField="CodigoEmpresa" caption="Código" alignment="right">
      </dxi-column>

      <dxi-column dataField="CodigoEmpresa" caption="Empresa">
        <dxo-lookup
          [dataSource]="companies"
          valueExpr="companyCode"
          displayExpr="companyName"
        ></dxo-lookup>
      </dxi-column>

      <!-- Templates -->
      <ng-container *ngIf="isCrud">
        <dxi-column dataField="Id" caption="Acciones" [allowFiltering]="false" [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
          <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onClickEdit(data.value)">
            <i class="material-icons">edit</i>
          </button>
          <button rel="tooltip" type="button" class="btn btn-danger btn-action" (click)="onClickDelete(data.value, data.rowIndex)">
            <i class="material-icons">close</i>
          </button>
        </ng-container>
      </ng-container>

      <!-- Añadir nuevos -->
      <div *dxTemplate="let data of 'addNew'">
        <button class="btn btn-primary btn-sm btn-add" (click)="onClickAdd()">
          <i class="material-icons">add</i> <span class="d-none d-sm-inline-block">Nuevo</span></button>
      </div>
    </dx-data-grid>
  </app-generic-panel>
</app-generic-container>
